import axios from 'axios';

export const HTTP = axios.create({
    baseURL: `http://tatnaywonproperty.com/api/`,
    // baseURL: `http://localhost/projects/tatnaywonproperty/api/`,

})